export const getMargin = ({ totalCosts, totalQuotes }: { totalCosts?: number; totalQuotes?: number }): number => {
  if (totalCosts === undefined || totalQuotes === undefined || totalQuotes === 0) {
    return 0;
  }

  return (1 - totalCosts / totalQuotes) * 100;
};

export const roundUpToNearestHundred = (value: number) => Math.ceil(value / 100) * 100;
